module.exports = __webpack_public_path__ + "img/rabbit_half.700ae211.svg";